"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpError = void 0;
const class_transformer_validator_1 = require("class-transformer-validator");
const defaultTransformValidationOptions = {
    validator: {
        forbidUnknownValues: true,
    },
};
/**
 * An HTTP Error
 * mesasge and status code are returned in responses
 */
class HttpError extends Error {
    static fromJSON(src) {
        const transformed = (0, class_transformer_validator_1.transformAndValidateSync)(this, src, defaultTransformValidationOptions);
        if (Array.isArray(transformed)) {
            throw new Error('Expected a single instance from JSON string but got an array');
        }
        return transformed;
    }
    constructor(status, code, message, functionalErrors, metaData, options) {
        super(message, options);
        this.statusCode = status;
        this.code = code;
        this.metaData = metaData;
        this.functionalErrors = functionalErrors;
    }
    toJSON() {
        const { message, code, statusCode, metaData, functionalErrors } = this;
        // Needed because Error message prop is not enumarable and we don't want to serialize error.cause.
        return { statusCode, message, code, metaData, functionalErrors };
    }
}
exports.HttpError = HttpError;
